import CryptoJS from "crypto-js/crypto-js";

/*
 * 1.默認KEY,IV，如果在加密解密的時候沒有傳入KEY和IV,就會使用這裡定義的
 * 2.前後端交互時需要前後端密鑰和初始向量保持一致
 */

const KEY = CryptoJS.enc.Utf8.parse("1288187898882222"); //密鑰:長度必須為16位
const IV = CryptoJS.enc.Utf8.parse("60NNwyJhTesysWpM"); //初始向量

/*
 * AES加密：資料,key,iv
 */
export function Encrypt(word, keyStr, ivStr) {
  let key = KEY;
  let iv = IV;

  if (keyStr && ivStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypt = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC, //可以選擇AES加密的模式
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypt.toString();
}

/*
 * AES解密：資料,key,iv
 */
export function Decrypt(word, keyStr, ivStr) {
  let key = KEY;
  let iv = IV;

  if (keyStr && ivStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(word));
  let decData = CryptoJS.enc.Base64.parse(encData).toString(CryptoJS.enc.Utf8);

  let decrypt = CryptoJS.AES.decrypt(decData, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC, //可以選擇AES加密的模式
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypt.toString(CryptoJS.enc.Utf8);
}